import React, { useEffect, useRef, useState } from 'react'
import styles from './Clock.module.css'

const Clock = ({ selectedDate, setSelectedDate }) => {
  const [now, setNow] = useState(new Date())
  const inputRef = useRef(null)

  useEffect(() => {
    const clock = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(clock)
  })

  const today = new Date().toISOString().slice(0, 10)

  const displayDateFull = selectedDate
    ? new Date(selectedDate + 'T00:00:00').toLocaleDateString('ru', {
        weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric',
      })
    : now.toLocaleDateString('ru', {
        weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric',
      })

  const displayDateShort = selectedDate
    ? new Date(selectedDate + 'T00:00:00').toLocaleDateString('ru', {
        year: 'numeric', month: 'numeric', day: 'numeric',
      })
    : now.toLocaleDateString('ru', {
        year: 'numeric', month: 'numeric', day: 'numeric',
      })

  const timeString = now.toLocaleTimeString('ru', { hour: 'numeric', minute: 'numeric' })
  const prefix = selectedDate && selectedDate !== today ? 'Меню на' : 'Сегодня'
  const showTime = !selectedDate || selectedDate === today

  const handleClick = () => {
    try { inputRef.current?.showPicker() } catch { inputRef.current?.click() }
  }

  return (
    <div className={styles.clock}>
      <div className={styles.dateWrapper} onClick={setSelectedDate ? handleClick : undefined}>
        <span className={styles.dateFull}>
          {prefix} {displayDateFull} {showTime ? timeString : ''}
        </span>
        <span className={styles.dateShort}>
          {displayDateShort} {showTime ? timeString : ''}
        </span>
        {setSelectedDate && (
          <input
            ref={inputRef}
            type="date"
            className={styles.dateInput}
            value={selectedDate || today}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        )}
      </div>
    </div>
  )
}

export default Clock
